'use client'

import { Text, DictionaryText, StackTrace } from '@lib-components'
import { use } from 'react'
import { ConfigContext } from '@/providers/config-provider'
import ErrorPage from '@/components/error/ErrorPage'

const MESSAGE_KEYS = {
    ERROR_PAGE_TITLE: 'STO.ERROR.ERROR_PAGE.TITLE',
    ERROR_PAGE_DESCRIPTION: 'STO.ERROR.ERROR_PAGE.DESCRIPTION',
}

export default function GlobalError({ error, reset: _reset }: { error: Error & { digest?: string }; reset: () => void }) {
    const { envVariables } = use(ConfigContext)

    const shouldShowStackTrace = !!envVariables?.NEXT_PUBLIC_IS_DEVELOPMENT

    return (
        <html lang="nl">
            <body>
                <ErrorPage
                    title={
                        <>
                            500 - <DictionaryText textKey={MESSAGE_KEYS.ERROR_PAGE_TITLE} />
                        </>
                    }
                >
                    <>
                        <Text>
                            <DictionaryText textKey={MESSAGE_KEYS.ERROR_PAGE_DESCRIPTION} />
                        </Text>
                        {shouldShowStackTrace && <StackTrace error={error} />}
                    </>
                </ErrorPage>
            </body>
        </html>
    )
}
